import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'input',
      label: '主体ID',
      placeholder: '请输入主体ID'
    },
    {
      field: 'corpName',
      type: 'input',
      label: '主体名称',
      placeholder: '请输入主体名称'
    }
  ]
}
